import { CheckCircle, MessageSquare } from "lucide-react";
import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";

export default function VehicleHistoryList({ history }) {
  if (!history || history.length === 0) return null;
  
  return (
    <div className="space-y-4">
      {history.map((entry, idx) => (
        <div key={idx} className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
            <CheckCircle className="h-5 w-5 text-emerald-600" />
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between">
              <p className="font-semibold text-slate-900 capitalize">{entry.step}</p>
              <p className="text-sm text-slate-500">
                {format(parseISO(entry.completed_at), "dd MMM yyyy HH:mm", { locale: fr })}
              </p>
            </div>
            <p className="text-sm text-slate-600">Par {entry.completed_by}</p>
            {entry.notes && (
              <div className="mt-2 p-2 bg-slate-50 rounded text-sm text-slate-700">
                <MessageSquare className="h-4 w-4 inline mr-1" />
                {entry.notes}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
